import { type Effect, takeEvery } from 'redux-saga/effects';
import { LOAD as LOAD_REQUIRED_FIELDS } from '../../state/domain/update-jira/required-fields/actions.tsx';
import { LOAD as LOAD_CHANGE_STATUS } from '../../state/domain/update-jira/change-status/actions.tsx';
import { CLOSE_UPDATE_JIRA_DIALOG } from '../../state/ui/top/title-bar/update-jira/actions.tsx';
import { doHandleManualCreate } from './manual-create/doHandleManualCreate.tsx';
import { doHandleChangeStatus } from './change-status/doHandleChangeStatus.tsx';
import { doHandleCloseDialog } from './close-dialog/doHandleCloseDialog.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* resolveIssueWarning(): Generator<Effect, void, any> {
	yield takeEvery(LOAD_REQUIRED_FIELDS, doHandleManualCreate);
	yield takeEvery(LOAD_CHANGE_STATUS, doHandleChangeStatus);
	yield takeEvery(CLOSE_UPDATE_JIRA_DIALOG, doHandleCloseDialog);
}
